import React from 'react';
import styled from 'styled-components';
import { height } from 'styled-system';
import { Text } from 'rebass/styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import GlobalFooter from 'components/global-footer-rebrand';
import MarketingHeader from 'marketing/components/marketing-header';
import Wrapper from 'components/wrapper';
import MetaTags from 'components/meta-tags';
import { Link } from 'components/core';

export default function DispoTermsPage() {
  return (
    <Wrapper>
      <MetaTags variant='dispoTerms' />
      <MarketingHeader variant='legal' />
      <PageContentContainer>
        {/* eslint-disable */}
        <H1>Dutchie Dispensary Terms and Conditions</H1>
        <br />
        <P>Last Updated: May 13, 2021</P>
        <br />
        <P>
          Courier Plus Inc. dba Dutchie ("Company" or "Dutchie") will provide the services ordered by the Retailer
          ("Brand") though the Dutchie Site or through a separately executed Statement of Work, which may include,
          software, technology, tools, expertise, support, and other related services in connection with Dutchie’s
          online cannabis ordering platform (the "Dutchie Platform") made available to the Brand’s third party consumers
          on the Dutchie website ("Dutchie Site") or through integration into the Brand’s website ("Brand Site"). The
          Dutchie Platform may be integrated into a Brand Site via iFrame or similar methods or, for Dutchie Plus
          customers, via API ("Dutchie Plus API") (collectively the "Service(s)") for the duration of the Term and in
          accordance with these Dutchie Dispensary Terms and Conditions ("Terms and Conditions") and the applicable
          Terms of Service (if any) on the Dutchie Site (
          <Link href='/terms'>
            <a href='https://dutchie.com/terms'>https://dutchie.com/terms</a>
          </Link>
          ) (collectively, the "Agreement"). The Agreement represents Brand’s agreement to purchase and pay for the
          Services pursuant to the Terms and Conditions. Brand represents and agrees that by signing up for the
          Services, (i) Brand has reviewed and expressly agrees to all of the terms of this Agreement and the Terms and
          Conditions, (ii) this is a legally binding order for and purchase of Services, and (iii) the individual who
          has agreed to this Agreement on Brand’s behalf is authorized to do so and to bind Brand to the obligations
          hereunder. This Agreement shall be in effect as of the date that Brand signs up for the Services on the
          Dutchie Site (the "Effective Date"). Brand may engage Company to reduce the Services provided, or to provide
          additional Services under this Agreement by requesting an amendment to the Agreement or executing additional
          Agreements. Any such amendment to any Agreement must be agreed to by the parties in writing. All payments
          shall be made by check, ACH, or credit card. Company may change the Agreement from time to time by providing
          thirty (30) days prior notice either by emailing the email address associated with your account or by posting
          a notice on the Company site ("Update Notice"). You can review the most current version of this Agreement at
          any time at{' '}
          <a href='https://admin.dutchie.com/images/legal-terms.pdf'>
            https://admin.dutchie.com/images/legal-terms.pdf
          </a>
          . The revised Agreement will become effective upon your review and acceptance of the revised Agreement on the
          Dutchie Site after being prompted on the Dutchie Site, or your use after the Updated Notice will constitute
          acceptance of the revised Agreement. If any change to this revised Agreement is not acceptable to you, you may
          either discontinue use of the Services or send a cancellation email to{' '}
          <a href='mailto:support@dutchie.com'>support@dutchie.com</a>.
        </P>
        <br />
        <SectionHeader>1. SERVICES AND SUPPORT</SectionHeader>
        <P>
          Company shall provide mutually agreed Services to or on behalf of Brand as set forth in this Agreement. Any
          placement of advertising, menu listing, and promotional content on Brand’s behalf on the Dutchie Platform,
          with the exception of Brand Sites created using the Dutchie Plus API, shall be provided at Company's sole
          discretion, subject to said Agreement. Company is not a courier or curb-side pickup service, Brand is fully
          responsible for actual delivery of any products offered by Brand through the Services.
        </P>
        <P>
          Subject to the terms of this Agreement, Company will use commercially reasonable efforts to provide Brand the
          Services and support for all Software, and hereby grants Brand a non-exclusive right to access and use the
          Services and Software.
        </P>
        <br />
        <SectionHeader>2. RESTRICTIONS; RESPONSIBILITIES; INDEMNITY</SectionHeader>
        <P>
          Brand will not, directly or indirectly: reverse engineer, decompile, disassemble or otherwise attempt to
          discover the source code, object code or underlying structure, ideas, know-how or algorithms relevant to the
          Services or any software, documentation or data related to the Services ("Software"); modify, translate, or
          create derivative works based on the Services or any Software (except to the extent expressly permitted by
          Company or authorized within the Services); use the Services or any Software for time sharing or service
          bureau purposes or otherwise for the benefit of a third party; or remove or alter any proprietary notices or
          labels. With respect to any Software that is distributed or provided to Brand for use on Brand premises or
          devices, Company hereby grants Brand a non-exclusive, non-transferable, non-sublicensable license to use such
          Software during the Term only in connection with the Services and only for the locations authorized in the
          Agreement.
        </P>
        <P>
          Brand shall be responsible for obtaining and maintaining any Company Order Terminal, equipment and ancillary
          services needed to connect to, access or otherwise use the Services, including, without limitation, tablets,
          modems, hardware, servers, software, operating systems, networking, web servers and the like (collectively,
          "Equipment"). Brand shall also be responsible for maintaining the security of the Equipment, Brand account,
          passwords (including but not limited to administrative and user passwords) and files, and for all uses of
          Brand account or the Equipment with or without Brand’s knowledge or consent. Access to the Services may be
          through a secure connection with the public internet and Brand acknowledges and agrees that Company is not
          responsible or liable for public internet disruptions or third-party network provider disruptions.
        </P>
        <P>
          Brand and Company each represent and warrant that during any period in which Brand’s products are listed on
          the Services or Company otherwise provides Services (a) it is legally organized under and is and will be in
          compliance with all applicable local, state, provincial, and federal laws and regulations, (b) Brand has
          active and valid permits or licenses issued by the applicable local, state, provincial and/or federal
          regulatory authority related to the sale of cannabis and is in compliance with all local, state, provincial,
          and federal laws and regulations related to the sale of cannabis, as amended from time to time, of the
          jurisdiction in which it operates; (c) Brand has obtained any and all additional authorizations, approvals,
          consents, licenses or permits required by respective local government regulatory or licensing authorities
          relating to the sale of cannabis; (d) Brand is located in a jurisdiction where access to the Services is not
          prohibited; (e) Brand’s products, marketing materials, and packaging are in compliance with all applicable
          state, local, provincial and federal laws and regulations, (f) Company’s Services and the Services are in
          compliance with all local, provincial, and state laws and regulations.
        </P>
        <P>
          Brand agrees to immediately notify Company and cease use of the Services if there is a change in the status of
          its legal authorization to sell cannabis, including expiration, suspension, cancellation, revocation,
          nonexistence or invalidation of any cannabis-related license or permit.
        </P>
        <P>
          The production, sale, possession and use of cannabis is illegal under federal law in the United States.
          Cannabis is currently classified as a Schedule I controlled substance under the federal Controlled Substances
          Act ("CSA"). While the sale and possession of cannabis has been legalized under certain state laws in the
          U.S., those laws are subject to change and to federal preemption. The sale and possession of cannabis may
          remain illegal under U.S. federal law and the federal government could take prosecutorial action. References
          to applicable law in this Agreement exclude the CSA and other U.S. federal laws implicated by the CSA.
        </P>
        <P>
          Brand agrees to comply with all applicable truth-in-advertising, Health Canada Act requirements, Cannabis Act
          requirements, and other advertising and consumer protection laws and regulations with respect to the marketing
          of Brand’s products listed on the Dutchie Site and Brand agrees that (a) Brand is solely liable for
          information ("Brand Information") it provides to Company regarding the listing of Brand products on the
          Dutchie Platform, (b) Company has no duty to verify or research the Brand Information provided by Brand, and
          (c) Company has no liability with respect to the display or advertising of such Brand Information, including
          but not limited to third party claims, governmental actions, or consumer actions or complaints.
        </P>
        <P>
          Brand agrees to defend, indemnify and hold Company, its affiliates, its licensors, and each of their officers,
          directors, employees, attorneys and agents harmless from and against any and all third-party claims, costs,
          damages, judgments, decrees, fines, penalties, liabilities and expenses (including reasonable legal fees and
          litigation costs), or governmental or administrative proceedings, arising out of any third party claim or
          governmental action in connection with: (a) Brand’s breach of this Agreement or violation of any applicable
          law or regulation (including without limitation laws and regulations regarding cannabis product liability, the
          marketing and sale of cannabis products, and/or intellectual property infringement), whether or not referenced
          herein in connection with Brand’s use of the Services, and/or (b) Brand’s (or Brand’s employees’, contractors’
          or agents’) gross negligence or intentional misconduct. Although Company has no obligation to monitor Brand’s
          use of the Services, Company may do so and may prohibit any use of the Services it believes may be (or alleged
          to be) in violation of the foregoing. Any claim for indemnification pursuant to this Section must be provided
          promptly in writing to the indemnifying party. The indemnifying party shall have sole discretion over the
          defense of such claim, provided that it shall not settle such claim whereby any indemnified party must pay any
          compensation or admit any liability without the indemnified party’s prior written authorization (which shall
          not be unreasonably withheld). At the indemnified party’s own cost, the indemnified party shall have the right
          to retain its own legal counsel. At the indemnifying party’s costs, the indemnified party shall provide
          reasonable cooperation to the indemnifying party in the defense of the indemnifiable claim. The obligation to
          indemnify and defend under this Section shall not apply to the extent the indemnified party is liable for the
          indemnifiable claim.
        </P>
        <P>
          Pursuant to the terms hereof, and to the extent permitted by law, Dutchie shall defend, indemnify, and hold
          Brand and each of its officers, directors, shareholders, employees, sister companies, affiliates, successors,
          assigns, assignees, heirs, and commonly-controlled entities (each a "Brand Affiliate") harmless from and
          against any liability, losses, fines, penalties, claims, complaints, petitions, administrative actions,
          demands, damages, and costs, including attorney’s fees, arising out of any third party claim or governmental
          action in connection with the e-commerce services and the Dutchie Plus API provided by Dutchie to Brand.
        </P>
        <SectionHeader>3. CONFIDENTIALITY; PROPRIETARY RIGHTS</SectionHeader>
        <P>
          Each party (the "Receiving Party") understands that the other party (the "Disclosing Party") has disclosed or
          may disclose business, technical or financial information relating to the Disclosing Party’s business
          (hereinafter referred to as "Proprietary Information" of the Disclosing Party). Proprietary Information of
          Company includes non-public information regarding features, functionality, pricing, and performance of the
          Service, Software and Services ("Company Data"). Proprietary Information of Brand includes non-public data
          provided by Brand to Company to enable the provision of the Services ("Brand Data"). The Receiving Party
          agrees: (i) to take reasonable precautions to protect such Proprietary Information, and (ii) not to use
          (except in performance of the Services or as otherwise permitted herein) or divulge to any third person any
          such Proprietary Information. The Disclosing Party agrees that the foregoing shall not apply with respect to
          any information after five (5) years following the disclosure thereof or any information that the Receiving
          Party can document (a) is or becomes generally available to the public, or (b) was in its possession or known
          by it prior to receipt from the Disclosing Party, or (c) was rightfully disclosed to it without restriction by
          a third party, or (d) was independently developed without use of any Proprietary Information of the Disclosing
          Party or (e) is required to be disclosed by law. Provided however, Company Data shall be kept confidential for
          so long that any portion of such Company Data remains a trade secret under applicable law.
        </P>
        <P>
          Company owns all right, title and interest in and to (a) the Services and Software, and all improvements,
          enhancements or modifications thereto, (b) any software, applications, inventions or other technology
          developed in connection with the Services or support, (c) all feedback provided by Brand relating to the
          Services, and (d) all intellectual property rights related to any of the foregoing.
        </P>
        <P>
          Notwithstanding anything to the contrary, Company shall have the right to collect and analyze data and other
          information relating to the provision, use and performance of various aspects of the Services and related
          systems and technologies (including, without limitation, information concerning Brand Data and data derived
          therefrom), and Company will be free (during and after the term hereof) to (i) use such information and data
          to improve and enhance the Services and for other development, diagnostic and corrective purposes in
          connection with the Services and other Company offerings, and (ii) disclose such data solely in aggregate or
          other de-identified and anonymized form in connection with its business for marketing purposes. No rights or
          licenses are granted except as expressly set forth herein.
        </P>
        <P>
          Brand hereby grants Company a limited license to use, display, and copy Brand’s copyrights, trademarks, trade
          names, and trade dress as necessary for Company to provide the Services listed in an applicable Agreement.
        </P>
        <P>Company utilizes industry standard data storage and protection measures in the delivery of Services.</P>
        <SectionHeader>4. FEES AND PAYMENTS</SectionHeader>
        <P>
          All fees are set forth in an applicable Agreement. Company has the right to modify its fees any time upon
          thirty (30) days’ written notice to Brand. Fees are based on the general use of the Company Services and not
          volume of sales. Payment obligations are non-cancelable and fees paid are non-refundable. Monthly fees will be
          invoiced by Company and shall be paid within seven (7) days following the date of receipt of said invoice by
          Brand. Other payment terms shall be as set forth in the applicable Agreement. Company shall not be compensated
          for procurement or sale of cannabis and shall not be a party to any transaction between any Brand and Brand’s
          customers. The parties agree that such transactions shall solely be between Brand and their customers.
        </P>
        <P>
          All amounts listed in the Agreement or verbally agreed upon are exclusive of any taxes. Brand will be
          responsible for all taxes, including sales or use taxes, imposed on such amounts, excluding taxes on Company’s
          net income. Brand will communicate to Company complete and accurate billing and contact information at all
          times. All prepaid fees (if any) are non-refundable, except as otherwise expressly set forth hereunder, with
          all balances due and payable to be paid in full. All Services purchased hereunder are non-cancelable, except
          as otherwise expressly set forth hereunder. If Company has the legal obligation to pay or collect taxes for
          which Brand is responsible under this paragraph, the appropriate amount shall be invoiced to and paid by
          Brand, unless Brand provides Company with a valid tax exemption certificate authorized by the appropriate
          taxing authority.
        </P>
        <P>
          If any charges or fees are not received from Brand by the due date, then at Company’s discretion, (a) such
          charges may accrue late interest at the rate of 1.5% of the outstanding balance per month (equivalent to
          19.56% per annum), or the maximum rate permitted by law, whichever is lower, from the date such payment was
          due until the date paid. Additionally, Brand will be responsible for paying all fees and costs of collection
          for unpaid amounts due and owing hereunder, including reasonable attorneys’ fees.
        </P>
        <P>
          If any amount owing by Brand hereunder is more than thirty (30) days overdue, Company may, in addition to all
          other remedies, suspend the Services immediately until such amounts are paid in full.
        </P>
        <P>
          If Brand uses the Services for payment processing, Brand acknowledges that payment processing is performed by
          a third-party processor ("Processor"). Company is not a bank, payment institution, or money services business
          and the processing and settlement of transactions is carried out solely by Processor. Brand is solely
          responsible for transactions processed by Processor, verifying the identity of customers and of the
          eligibility of a presented card used to purchase Brand’s products and services, and Company does not guarantee
          or assume any liability for transactions authorized and completed that may later be reversed or charged back.
          Brand is solely responsible for all reversed or charged back transactions regardless of the reason for, or
          timing of the reversal or chargeback and for compliance with all associated applicable laws regulations.
        </P>
        <SectionHeader>5. TERM AND TERMINATION</SectionHeader>
        <P>
          Subject to earlier termination as provided below, the Term is as specified in the Agreement, and shall be
          automatically renewed for additional periods of the same duration as the Initial Service Term (collectively,
          the "Term"), unless either party terminates the Agreement termination in writing on at least thirty (30) days’
          written notice for convenience.
        </P>
        <P>
          In addition to any other remedies it may have, either party may also terminate this Agreement upon ten (10)
          days’ written notice (or without notice in the case of nonpayment), if the other party materially breaches any
          of the terms or conditions of this Agreement. Brand will pay in full for the Services up to and including the
          last day on which the Services are provided. All sections of this Agreement which by their nature should
          survive termination will survive termination, including, without limitation, accrued rights to payment,
          confidentiality obligations, indemnities, warranties, warranty disclaimers, and limitations of liability.
        </P>
        <SectionHeader>6. LIMITATION OF LIABILITY</SectionHeader>
        <P>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, COMPANY AND ITS SUPPLIERS (INCLUDING BUT NOT LIMITED TO ALL EQUIPMENT
          AND TECHNOLOGY SUPPLIERS), OFFICERS, AFFILIATES, REPRESENTATIVES, CONTRACTORS AND EMPLOYEES SHALL NOT BE
          RESPONSIBLE OR LIABLE WITH RESPECT TO ANY SUBJECT MATTER OF THIS AGREEMENT OR TERMS AND CONDITIONS RELATED
          THERETO UNDER ANY CONTRACT, NEGLIGENCE, STRICT LIABILITY OR OTHER THEORY: (A) FOR ERROR OR INTERRUPTION OF USE
          OR FOR LOSS OR INACCURACY OR CORRUPTION OF DATA OR COST OF PROCUREMENT OF SUBSTITUTE GOODS, SERVICES OR
          TECHNOLOGY OR LOSS OF BUSINESS; (B) FOR ANY INDIRECT, EXEMPLARY, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES;
          OR (C) FOR ANY MATTER BEYOND COMPANY’S REASONABLE CONTROL; (D) FOR ANY FINES, PENALTIES, OR COSTS ASSOCIATED
          WITH OR RELATING TO BREACH OF LAWS, REGULATIONS, OR ARISING FROM REGULATORY OR ADMINISTRATIVE PROCEEDINGS; OR
          (E) FOR ANY AMOUNTS THAT, TOGETHER WITH AMOUNTS ASSOCIATED WITH ALL OTHER CLAIMS, EXCEED THE FEES PAID BY
          BRAND TO COMPANY FOR THE SERVICES UNDER THIS AGREEMENT IN THE 12 MONTHS PRIOR TO THE ACT THAT GAVE RISE TO THE
          LIABILITY, IN EACH CASE, WHETHER OR NOT COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. COMPANY
          SPECIFICALLY DISCLAIMS AND EXCLUDES ALL WARRANTIES UNDER APPLICABLE SALE OF GOODS ACT LEGISLATION.
        </P>
        <SectionHeader>7. WARRANTIES; DISCLAIMER</SectionHeader>
        <P>
          Company represents and warrants that it will, consistent with prevailing industry standards, perform the
          Services in a professional and workmanlike manner and the Services shall conform in all material respects with
          documentation. For material breach of the foregoing express warranty, Brand’s exclusive remedy shall be the
          re-performance of the deficient Services. Brand represents and warrants that the pricing provided by Brand for
          its products and services listed on the Dutchie Platform, whether electronically or otherwise, are complete
          and accurate.
        </P>
        <P>
          EXCEPT AS SET FORTH HEREIN, THE SERVICES DELIVERED UNDER THIS AGREEMENT, AND ANY INFORMATION SUPPLIED
          THEREWITH ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND; WITHOUT LIMITING THE GENERALITY OF THE FOREGOING:
          I) COMPANY DOES NOT MAKE AND HEREBY DISCLAIMS ANY WARRANTY, EXPRESS OR IMPLIED, WITH RESPECT TO THE SERVICES
          PROVIDED HEREUNDER; II) COMPANY DOES NOT GUARANTEE OR WARRANT CORRECTNESS, COMPLETENESS, MERCHANTABILITY, OR
          FITNESS FOR A PARTICULAR PURPOSE OF THE SERVICES OR INFORMATION PROVIDED HEREUNDER, OR THAT THE PRICING FOR
          ANY PRODUCT LISTED ON THE DUTCHIE PLATFORM REFLECTS THE ACTUAL PRICE FOR SUCH PRODUCT; AND III) COMPANY
          DISCLAIMS ALL WARRANTIES RELATED TO THIRD PARTY PAYMENT PROCESSORS AND ANY DISCREPANCIES, MISTAKES, OR
          INACCURACIES CAUSED BY THIRD PARTY PAYMENT PROCESSORS.
        </P>
        <SectionHeader>8. PRIVACY</SectionHeader>
        <P>
          The parties to this Agreement acknowledge and agree that Brand and Company are each responsible for complying
          with their respective obligations under all applicable privacy laws and regulations.
        </P>
        <P>
          The Parties represent and warrant, in connection with any personal information disclosed by one Party to the
          other, or otherwise accessed or compiled by or transferred to any Party for handling under, arising from the
          Agreement in the course of Company performing the Services (the "<Bold>Personal Information</Bold>"), that
          each Party: (i) has in place the industry standard technical and organizational security measures to protect
          such Personal Information against accidental or unlawful destruction or unauthorized disclosure or access;
          (ii) has maintained and will continue to maintain suitable records in commercially reasonable detail with
          respect to such Personal Information; (iii) will not use such Personal Information for any purpose other than
          as set out in this Agreement; (iv) will not transfer such Personal Information to any third party except to
          its employees, subcontractors, or agents who require access to it in order to fulfill such purposes; (v) will
          not transfer such Personal Information to any foreign jurisdiction outside of Canada or the United States (as
          applicable) unless in accordance with applicable laws or as otherwise agreed to in writing by the other party;
          and (vi) will comply with all applicable privacy laws.
        </P>
        <P>
          Where either Party provides the other Party with Personal Information or where Company obtains Personal
          Information from the Services, such Party confirms and agrees that such Personal Information has been lawfully
          obtained and that all data subjects have been provided all notices and/or granted all consents as are required
          under applicable privacy laws for the disclosure and use of their Personal Information as contemplated
          hereunder. Each Party agrees to promptly inform the other Party of any withdrawn or changed consents of the
          data subjects which may affect the use of such Personal Information under this Agreement.
        </P>
        <P>
          To the extent any Personal Information is governed by the California Consumer Privacy Act (together with any
          implementing regulations and as may be amended from time to time, the "<Bold>CCPA</Bold>"), the Parties agree
          that (A) for such Personal Information about California residents collected through the Dutchie Site ("
          <Bold>Dutchie Site PI</Bold>"), (1) each Party is considered to be an independent "business," and neither
          Party is a "service provider" to the other Party (as those terms are defined in the CCPA); (2) the Parties
          shall only share such Dutchie Site PI of data subjects who have directed the Party to intentionally disclose
          the Dutchie Site PI to the other Party or otherwise intentionally interacts with the receiving Party; and (3)
          such Dutchie Site PI is not provided in exchange for monetary or other valuable consideration, but rather as a
          condition precedent to perform the obligations outlined in this Agreement; and (B) for such Personal
          Information about California residents collected through a Brand Site ("<Bold>Brand Site PI</Bold>
          "), (1) that Brand is a "business" and Company is a "service provider" (as those terms are defined in the
          CCPA); (2) Brand will only provide or make Brand Site PI available to Company in compliance with the CCPA; and
          (3) Company shall not retain, use, sell, or disclose Brand Site PI other than as provided for in the
          Agreement, as needed to perform the Services, to build or improve the quality of the Services, to detect
          security incidents, to protect against fraudulent or illegal activity, to employ subcontractors that qualify
          as "service providers," or as otherwise permitted by the CCPA. Company understands and will comply with these
          restrictions on the Brand Site PI.
        </P>
        <SectionHeader>9. MISCELLANEOUS</SectionHeader>
        <P>
          If any provision of this Agreement is found to be unenforceable or invalid, that provision will be limited or
          eliminated to the minimum extent necessary so that this Agreement will otherwise remain in full force and
          effect and enforceable. This Agreement is not assignable, transferable or sublicensable by Brand except with
          Company’s prior written consent. Company may transfer and assign any of its rights and obligations under this
          Agreement without consent. This Agreement is the complete and exclusive statement of the mutual understanding
          of the parties and supersedes and cancels all previous written and oral agreements, communications and other
          understandings relating to the subject matter of this Agreement, and that all waivers and modifications must
          be in a writing signed by both parties, except as otherwise provided herein. No agency, partnership, joint
          venture, or employment is created as a result of this Agreement and Brand does not have any authority of any
          kind to bind Company in any respect whatsoever. In any action or proceeding to enforce rights under this
          Agreement, the prevailing party will be entitled to recover costs and legal fees. All notices under this
          Agreement will be in writing and will be deemed to have been duly given when received, if personally
          delivered; when receipt is electronically confirmed, if transmitted by facsimile or email; the day after it is
          sent, if sent for next day delivery by recognized overnight delivery service; and upon receipt, if sent by
          certified or registered mail, return receipt requested. This Agreement shall be governed by the laws of the
          Province of Ontario if Brand’s principal place of business is in Canada, or the State of Oregon if the Brand’s
          principal place of business is in the United States, without regard to applicable conflict of laws provisions.
          This Agreement may be executed in any number of counterparts, each of which so executed shall be deemed to be
          an original, and such counterparts shall together constitute but one and the same Agreement. The parties shall
          be entitled to sign and transmit an electronic signature of this Agreement (whether by facsimile, PDF or other
          email transmission), which signature shall be binding on the party whose name is contained therein. Any party
          providing an electronic signature agrees to promptly execute and deliver to the other parties an original
          signed Agreement upon request. Brand agrees that Company may refer to Brand’s name and trademarks in Company’s
          marketing materials and Dutchie Site, including but not limited to displaying the Brand’s logo, developing a
          case study, and/or publishing a press release. Upon request, Brand further agrees to reasonably assist Company
          and serve as a reference.
        </P>
        {/* eslint-enable */}
      </PageContentContainer>
      <GlobalFooter />
    </Wrapper>
  );
}

export const PageContentContainer = styled.div`
  padding: ${() =>
    useMediaQuery((theme) => theme.breakpoints.down(`sm`)) ? `127px 25px 110px 25px` : `110px 245px 170px 245px`};

  ${height}
`;

export const Bold = styled.span`
  font-weight: bold;
  i {
    font-style: italic;
  }
`;

export const H1 = styled(Text)`
  font-size: 26.87px;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 20px;
  margin-top: 0;
`;

export const H2 = styled.h2`
  font-size: 1rem;
  font-weight: bolder;
  line-height: 1.5;
`;

export const SectionHeader = styled.h3`
  font-size: 1rem;
  font-weight: bolder;
  line-height: 1.5;
  margin-bottom: 20px;

  strong {
    text-decoration: none;
  }
`;

export const P = styled.p`
  font-size: 13px;
  line-height: 22px;
  margin-bottom: 20px;
  padding-right: 10px;

  > a {
    color: ${({ theme }) => theme.colors.sapphire};
    font-weight: 700;
  }
`;

export const List = styled.div`
  font-size: 13px;
  line-height: 22px;
  margin-bottom: 20px;
  padding-right: 10px;
`;

export const OL = styled.ol`
  counter-reset: list;
  margin: 15px 25px;
  li {
    list-style: none;
  }
  li:before {
    content: counter(list, lower-alpha) '. ';
    counter-increment: list;
    font-weight: bold;
  }
`;

export const UL = styled.ul`
  list-style: initial;
  margin: 15px 25px;
`;
